/**
 * stripMarkdown — strip markdown syntax so ElevenLabs doesn't literally read
 * asterisks, hashes, backticks, bullets, etc. Called before every /voice/speak
 * request.
 *
 * Scope:
 *   - Bold / italic / strikethrough markers (content preserved)
 *   - Headings (#)
 *   - Bullet list markers (-, *, +)
 *   - Numbered list markers (1., 2., ...)
 *   - Inline + fenced code (content preserved for inline, dropped for fenced)
 *   - Links / images (link text preserved; image alt dropped)
 *   - Blockquotes, horizontal rules
 *
 * Not handled: tables, HTML tags — rare in coaching responses.
 */
export function stripMarkdown(text) {
  if (!text) return '';
  let out = text;

  // Fenced code blocks — drop entirely (speaking code doesn't help)
  out = out.replace(/```[\s\S]*?```/g, '');

  // Images — drop entirely (alt text tends to be noisy)
  out = out.replace(/!\[[^\]]*\]\([^)]+\)/g, '');

  // Links — keep the link text only
  out = out.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Inline code — keep content without backticks
  out = out.replace(/`([^`]+)`/g, '$1');

  // Bold / italic / strikethrough
  out = out.replace(/\*\*(.+?)\*\*/g, '$1');
  out = out.replace(/__(.+?)__/g, '$1');
  out = out.replace(/~~(.+?)~~/g, '$1');
  out = out.replace(/\*(.+?)\*/g, '$1');
  // Italic with _ — only when flanked by non-word chars (avoid snake_case)
  out = out.replace(/(^|[^\w])_([^_\n]+)_(?=[^\w]|$)/g, '$1$2');

  // Line-level markers
  out = out.replace(/^#{1,6}\s+/gm, '');        // headings
  out = out.replace(/^\s*[-*+]\s+/gm, '');      // bullets
  out = out.replace(/^\s*\d+\.\s+/gm, '');      // numbered list
  out = out.replace(/^\s*[-*_]{3,}\s*$/gm, ''); // horizontal rules
  out = out.replace(/^>\s?/gm, '');             // blockquotes

  // Turn intra-chunk newlines into sentence breaks when the prior line didn't
  // already terminate. This makes "First\nSecond\nThird" speak as three sentences
  // instead of one run-on phrase.
  out = out.replace(/([^.!?\n])\n(?=\S)/g, '$1. ');

  // Collapse excess blank lines
  out = out.replace(/\n{3,}/g, '\n\n');

  return out.trim();
}
